module.exports = __webpack_public_path__ + "static/media/kongsberg-logo-charcoal.7d1928c9.svg";